import { render, staticRenderFns } from "./MaterialAndWorker.vue?vue&type=template&id=320c7414"
import script from "./MaterialAndWorker.vue?vue&type=script&lang=js"
export * from "./MaterialAndWorker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports